const SW_URL = '/legacy-crm-sw.js';
const POLL_INTERVAL_MS = 60 * 60 * 1000;

// Enabled in production, and locally with `SW_DEV=1 PORT=3001 npm run serve`
// so the caching behaviour is actually testable before it ships.
const enabled = 'serviceWorker' in navigator
  && (process.env.NODE_ENV === 'production' || process.env.SW_DEV === '1');

if (enabled) {
  // Registered immediately rather than on `load`: index.tsx dispatches getMe()
  // as soon as stored responses are read, so waiting would let the first
  // request outrun the controller.
  navigator.serviceWorker
    .register(SW_URL)
    .then((registration) => {
      // A browser only checks for a new worker on navigation or roughly daily,
      // so a long-lived tab would never notice a deploy without this.
      const poll = () => { registration.update().catch(() => undefined); };

      setInterval(poll, POLL_INTERVAL_MS);
      window.addEventListener('focus', poll);
    })
    .catch((error) => console.log('SW registration failed: ', error));

  // controllerchange also fires on the very first install, when clientsClaim
  // takes control. Reloading then would bounce every first-time visitor, so
  // only reload when we are genuinely replacing an existing controller.
  const hadController = Boolean(navigator.serviceWorker.controller);
  let reloading = false;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController || reloading) return;

    reloading = true;
    window.location.reload();
  });
}

/**
 * Drops cached API responses. CacheStorage is origin-scoped and outlives a
 * session, and this app holds vacations, sick leaves and salary data -- so the
 * cache must be cleared both on logout and on login, otherwise a second user on
 * the same browser can be shown the previous user's rows before revalidation
 * lands. Cleared from the page rather than via postMessage so it still works
 * when no worker is controlling yet.
 */
export const clearApiCache = async () => {
  if (typeof caches === 'undefined') return;

  try {
    const keys = await caches.keys();

    await Promise.all(
      keys.filter((key) => key.startsWith('api-')).map((key) => caches.delete(key)),
    );
  } catch {
    // Storage can be unavailable (private mode, blocked site data) -- never let
    // this break login or logout.
  }
};
